import { baseApi } from '@/store/baseApi';

import type {
  CreateDeliverableTypePayload,
  CreateDeliverableTypeResponse,
  DeleteDeliverableTypeParams,
  DeleteDeliverableTypeResponse,
  GetDeliverableTypesParams,
  GetDeliverableTypesResponse,
  UpdateDeliverableTypePayload,
  UpdateDeliverableTypeResponse,
} from '@/features/deliverable-types/types';
import type { APIResponse } from '@web/types';

export const deliverableTypesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDeliverableTypes: builder.query<
      APIResponse<GetDeliverableTypesResponse>,
      GetDeliverableTypesParams | void
    >({
      query: (params) => ({
        url: 'deliverable-types',
        method: 'GET',
        params: params ?? undefined,
      }),
      providesTags: [{ type: 'DeliverableTypes', id: 'LIST' }],
    }),
    createDeliverableType: builder.mutation<
      APIResponse<CreateDeliverableTypeResponse>,
      CreateDeliverableTypePayload
    >({
      query: (body) => ({
        url: 'deliverable-types',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'DeliverableTypes', id: 'LIST' }],
    }),
    updateDeliverableType: builder.mutation<
      APIResponse<UpdateDeliverableTypeResponse>,
      { deliverableTypeId: string; payload: UpdateDeliverableTypePayload }
    >({
      query: ({ deliverableTypeId, payload }) => ({
        url: `deliverable-types/${deliverableTypeId}`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: [{ type: 'DeliverableTypes', id: 'LIST' }],
    }),
    deleteDeliverableType: builder.mutation<
      APIResponse<DeleteDeliverableTypeResponse>,
      { deliverableTypeId: string; params?: DeleteDeliverableTypeParams }
    >({
      query: ({ deliverableTypeId, params }) => ({
        url: `deliverable-types/${deliverableTypeId}`,
        method: 'DELETE',
        params: params ?? undefined,
      }),
      invalidatesTags: [{ type: 'DeliverableTypes', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetDeliverableTypesQuery,
  useLazyGetDeliverableTypesQuery,
  useCreateDeliverableTypeMutation,
  useUpdateDeliverableTypeMutation,
  useDeleteDeliverableTypeMutation,
} = deliverableTypesApi;
